module.exports = __webpack_public_path__ + "static/img/2018120501.ce32e85.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/2018120501.jpg
// module id = EsrS
// module chunks = 1